import * as React from "react"

import { cn } from "@/lib/utils"

const Textarea = React.forwardRef(({ className, ...props }, ref) => {
  return (
    <textarea
      className={cn(
        "flex min-h-[88px] w-full rounded-[10px] border border-[var(--hr-border)] bg-white px-3 py-2 text-base leading-6 shadow-none transition-[border-color,box-shadow] duration-150 placeholder:text-[var(--hr-muted-2)] hover:border-[rgba(31,33,48,0.28)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 aria-[invalid=true]:border-[var(--hr-red)] lg:text-[15px]",
        className
      )}
      ref={ref}
      {...props} />
  );
})
Textarea.displayName = "Textarea"

export { Textarea }
